<template>
    <v-card class="pa-3 ma-md-3">
        <v-toolbar flat color="#1d2735" dark>
            <v-icon class="white--text" style="font-size: 45px"
                >mdi-account-supervisor-circle</v-icon
            >
            <pre><v-toolbar-title><h2>Abonos</h2></v-toolbar-title></pre>
        </v-toolbar>
        <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    fab
                    @click="OpenSaveDialog()"
                    :loading="isloading"
                    :disabled="isloading"
                    color="orange darken-1"
                    class="mt-2"
                    v-bind="attrs"
                    v-on="on"
                >
                    <v-icon class="white--text"
                        >mdi-account-plus-outline</v-icon
                    >
                </v-btn>
            </template>
            <span>Nuevo abono</span>
        </v-tooltip>
        <v-row style="padding: 1rem">
            <v-col cols="12">
                <h3>Importe</h3>
            </v-col>
            <v-col cols="12" md="4">
                <span>Factura: {{ formatPrice(this.factura.total) }} €</span>
            </v-col>
            <v-col cols="12" md="4">
                <span
                    >Abonado: {{ formatPrice(this.factura.totalAbono) }} €</span
                >
            </v-col>
            <v-col cols="12" md="4">
                <span
                    >Faltante:
                    {{ formatPrice(factura.pendiente != null ? factura.pendiente : faltante) }}
                    €</span
                >
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="4">
                <v-text-field
                    prepend-icon="mdi-account-search"
                    v-model="search"
                    label="Buscar"
                ></v-text-field>
            </v-col>
        </v-row>
        <v-data-table
            dense
            :headers="headers"
            :items="Abonos"
            :search="search"
            :items-per-page="15"
            item-key="id"
            class="elevation-1"
            :sort-by="['nombre']"
            :sort-desc="[false]"
        >
            <template v-slot:item.fecha="{ item }">
                <span>{{ item.created_at | format_date }}</span>
            </template>
            <template v-slot:item.importe="{ item }">
                <span>{{ formatPrice(item.importe) }} €</span>
            </template>
            <template v-slot:item.action="{ item }">
                <v-icon
                    @click="openEditModal(item)"
                    small
                    class="mr-2"
                    color="#1d2735"
                    style="font-size: 25px"
                    title="EDITAR"
                    >mdi-pencil-outline</v-icon
                >
                <v-icon
                    @click="openAsientoModal(item)"
                    small
                    class="mr-2"
                    color="#1d2735"
                    style="font-size: 25px"
                    title="APUNTES"
                    >mdi-cash</v-icon
                >
                <v-icon
                    @click="openModal(item)"
                    small
                    class="mr-2"
                    color="red"
                    style="font-size: 25px"
                    title="BORRAR"
                    >mdi-trash-can</v-icon
                >
            </template>
        </v-data-table>

        <!-- Dialog de guardado de abono -->
        <v-dialog v-model="save_dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Guardar abono
                </v-card-title>
                <v-card-text style="text-align: center">
                    <v-row>
                        <v-col col="12" md="6">
                            <date-select v-model="abono.fecha" label="Fecha">
                            </date-select>
                        </v-col>
                        <v-col col="12" md="6">
                            <v-text-field
                                v-model="abono.importe"
                                type="number"
                                label="Importe"
                            >
                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            save_dialog = false;
                            selectedItem = {};
                            clearAbono();
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="SaveAbono()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog de eliminacion de abono -->
        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>¿Estás seguro que deseas eliminar?</h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            dialog = false;
                            selectedItem = {};
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="deleteAbono()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog de asiento contable -->
        <DialogLibroDiario
            v-model="asiento_dialog"
            :id_factura="factura.id"
            :extra="facturaAsiento"
            :id_cliente="factura.id_cliente"
            :id_abono="abono.id"
            :abono="abono.importe"
        ></DialogLibroDiario>
    </v-card>
</template>
<script>
import DialogLibroDiario from "../../libroDiario/componentes/DialogLibroDiario.vue";
import { formatPrice } from "../../../helpers";

export default {
    components: { DialogLibroDiario },
    data() {
        return {
            asiento_dialog: false,
            factura: {
                total: 0,
                totalAbono: 0,
                pendiente: 0,
            },
            save_dialog: null,
            search: "",
            headers: [
                { text: "Nº Factura", value: "id_factura", sortable: false },
                { text: "Fecha", value: "fecha", sortable: false },
                { text: "Importe", value: "importe", sortable: false },
                { text: "Acciones", value: "action", sortable: false },
            ],
            abono: {
                id: null,
                id_factura: this.$route.query.id,
                fecha: null,
                importe: null,
            },
            Abonos: [],
            selectedItem: 0,
            dialog: false,
        };
    },
    created() {
        if (this.$route.query.id) {
            this.getAbonos(this.$route.query.id);
        }
    },
    methods: {
        openAsientoModal(item) {
            this.abono.id = item.id;
            this.abono.importe = item.importe;
            this.asiento_dialog = true;
        },
        openEditModal(item) {
            this.abono.id = item.id;
            this.abono.fecha = item.fecha;
            this.abono.importe = item.importe;
            this.save_dialog = true;
        },
        ClearAbono() {
            this.abono.id = null;
            this.abono.fecha = null;
            this.abono.importe = null;
        },
        SaveAbono() {
            axios.post(`api/save-abono`, this.abono).then(
                (res) => {
                    this.$toast.sucs("Abono guardado con éxito");
                    this.clearAbono();
                    this.save_dialog = false;
                    this.getAbonos(this.$route.query.id);
                },
                (err) => {
                    //console.log(error.response.status);
                    if (error.response.status == 400) {
                        this.$custom_error(error.response.data.mensaje);
                    } else {
                        this.$custom_error("Algo salió mal");
                    }
                }
            );
        },
        CloseSaveDialog() {
            this.save_dialog = false;
        },
        OpenSaveDialog() {
            this.ClearAbono();

            this.save_dialog = true;
        },
        getFactura(id) {
            axios.get(`api/get-factura/${id}`).then(
                (res) => {
                    this.factura = res.data;
                },
                (err) => {
                    this.$custom_error("Error consultando la factura");
                }
            );
        },
        getAbonos(id) {
            axios.get(`api/get-abonos/${id}`).then(
                (res) => {
                    this.Abonos = res.data.Abonos;
                    this.getFactura(id);
                },
                (err) => {
                    this.$custom_error("Error consultando los abonos");
                }
            );
        },
        openModal(item) {
            this.selectedItem = this.Abonos.indexOf(item);
            this.dialog = true;
        },
        deleteAbono() {
            axios
                .get(`api/delete-abono/${this.Abonos[this.selectedItem].id}`)
                .then(
                    (res) => {
                        this.$toast.sucs("Abono eliminado con éxito");
                        this.clearAbono();
                        this.dialog = false;
                        this.getAbonos(this.$route.query.id);
                    },
                    (err) => {
                        this.$custom_error("Error eliminando el abono");
                    }
                );
        },
        clearAbono() {
            this.abono = {
                id: null,
                id_factura: this.$route.query.id,
                fecha: null,
                importe: null,
            };
        },
        formatPrice,
    },
    computed: {
        faltante() {
            const total = Number(this.factura.total) || 0;
            const totalAbono = Number(this.factura.totalAbono) || 0;
            const totalBase = this.factura.nota === 1
                ? total
                : total * (1 + (Number(this.factura.iva) || 0) / 100);
            const p = totalBase >= 0 ? totalBase - totalAbono : totalBase + totalAbono;
            return Math.round(p * 100) / 100;
        },
        facturaAsiento() {
            let factura = this.factura;
            const incluyeIva = factura.incluir_iva && factura.iva != null && factura.iva != 0;
            const esNota = this.$route.meta.nota == 1;
            const porcentajeIva = incluyeIva && !esNota ? (factura.iva / 100) : 0;
            
            factura.subtotal = factura.total;
            factura.valor_iva = factura.subtotal * porcentajeIva;
            factura.total = factura.subtotal * (1 + porcentajeIva);
            factura.iva = incluyeIva && !esNota ? factura.iva : 0;
            return factura;
        },
        isloading: function () {
            return false;
        },
    },
};
</script>
